import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserManagementService {

  constructor(
    private _http: HttpClient
  ) { }

  getAssignedPermits() {
    return this._http.get<any>(`${environment.BACKEND}aclconfig/list`);
  }

  getActions() {
    return this._http.get<any>(`${environment.BACKEND}aclconfig/actions/list`);
  }

  getMenus() {
    return this._http.get<any>(`${environment.BACKEND}aclconfig/menu/list`);
  }

  getNotificationEvents() {
    return this._http.get<any>(`${environment.BACKEND}aclconfig/notification/list`);
  }

  changePermissions(profile_id, obj) {
    return this._http.post<any>(`${environment.BACKEND}aclconfig/new_permissions/${profile_id}`, obj);
  }
}
